import React from "react";
import { NavLink } from "react-router-dom";

const PageMenuData = () => {
    return (
        <div className="pageLeft_links">
            <span>
                <NavLink to="/terms-and-conditions">Terms and Conditions</NavLink>
            </span>
            <span>
              {" "}
              <NavLink to="/privacy-policy">Privacy Policy</NavLink>
            </span>
            {/* <span>
              {" "}
              <NavLink to="/feedback">Give Feedback</NavLink>
            </span> */}
            <span>
              {" "}
              <NavLink to="/contact-us">Contact us</NavLink>
            </span>
            <span>
              <NavLink to="/feedback">Feedback</NavLink>
            </span>
        </div>
    )
}
export default PageMenuData;